import { makeStyles } from '@mui/styles';
import { COLOR_GRAY_70, COLOR_PINK } from 'styles/variables/colors';

export const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: 30,
    color: COLOR_GRAY_70,
    maxWidth: 691,
    margin: '0 auto',
    textAlign: 'center',
    marginBottom: theme.spacing(6),

    '& span': {
      color: COLOR_PINK,
      fontWeight: 700,
    },
  },
  logoReact: {
    position: 'absolute',
    right: 0,
    top: 0,
  },
}));
